var _defs, _text, _text2, _text3, _path, _text4, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path5, _text5, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVetValueBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 722.37 393.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:183.57px;font-family:Optima-Regular, Optima;}.cls-1,.cls-4,.cls-5,.cls-6{fill:#002e6d;}.cls-2{letter-spacing:-0.05em;}.cls-3{fill:#cb9700;}.cls-4{font-size:16.03px;font-family:MyriadPro-Regular, Myriad Pro;}.cls-5{font-size:50px;font-family:ProximaNova-Regular, Proxima Nova;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(461.5 252.96)"
  }, "lue")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(257.62 252.96)"
  }, "V")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 252.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2"
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 112.35,
    y: 0
  }, "et"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.39,106.7S201,11.38,366.71,2.88C530.5-5.52,564.37,151.32,564.37,151.32S531,62.31,379.44,54.14C245.48,46.92,21.39,106.7,21.39,106.7Z"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(700.13 177.35)"
  }, "TM")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M595.83,73.36c-9.85,43.93-21.62,79.43-21.62,79.43a707.11,707.11,0,0,0,2.86-81.74,28.65,28.65,0,0,1,9.56-.33C592.7,71.47,595.83,73.36,595.83,73.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M632.42,91.19c-26,36.74-50.54,65-50.54,65A707.89,707.89,0,0,0,616,81.83a28.59,28.59,0,0,1,9,3.38C630.26,88.24,632.42,91.19,632.42,91.19Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M658.19,121.06C620,145,586.54,161.57,586.54,161.57a707.92,707.92,0,0,0,60.1-55.47,28.32,28.32,0,0,1,7,6.56C657.33,117.51,658.19,121.06,658.19,121.06Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 397.51,
    cy: 178.19,
    rx: 14.37,
    ry: 20.85
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 430.48,
    cy: 178.19,
    rx: 14.37,
    ry: 20.85
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 451.66,
    cy: 203.8,
    rx: 16.72,
    ry: 11.52,
    transform: "translate(63.88 512.29) rotate(-62.79)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 376.24,
    cy: 203.8,
    rx: 11.52,
    ry: 16.72,
    transform: "translate(-51.55 194.59) rotate(-27.21)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M414.86,207.58c9.9,0,14.71,2.15,25.35,16.13,10,13.15,15.18,21.14,6.23,28.46-9.38,7.67-20.87-2.84-30.32-2.84-9.66,0-23.49,9.63-31.62,2.84s-2.27-16.72,7.19-28.73C402.26,210,405.51,207.58,414.86,207.58Z"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(77.44 331.37)"
  }, "Empowering the Practice ", /*#__PURE__*/React.createElement("tspan", {
    x: 59.8,
    y: 50
  }, "Ownership Journey"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1.99,
    y: 280.8,
    width: 697.93,
    height: 1.46
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVetValueBig);
export default __webpack_public_path__ + "static/media/VetValueBig.2414351c96a9bd476145769dea9433ab.svg";
export { ForwardRef as ReactComponent };